<template>
  <BCard>
    <BRow class="mx-1 flex gap-2 items-center">
      <BButton
        variant="primary"
        size="sm"
        @click="$router.go(-1)"
      >
        <span class="k-arrow-left-2 text-white text-xl" />
      </BButton>
      <strong class="text-[20px] text-black font-semibold ml-1">
        Ubah Coverage Area
      </strong>
    </BRow>

    <BRow class="w-full mt-5">
      <form
        class="w-full max-w-[450px]"
        action=""
      >
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Provinsi
            </template>
            <VSelect
              v-model="province"
              :reduce="option => option.label"
              :options="provinceList"
              class="rekonsiliasi-vselect"
              :filterable="true"
              :clearable="false"
              placeholder="Cari Provinsi"
              @input="searchCity"
            />
          </BFormGroup>
        </BCol>
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Kabupaten/Kota
            </template>
            <VSelect
              v-model="city"
              label="city"
              :reduce="option => option.city"
              :options="cityList"
              class="rekonsiliasi-vselect"
              :filterable="true"
              :clearable="false"
              :disabled="province === ''"
              placeholder="Cari Kabupaten/Kota"
            />
          </BFormGroup>
        </BCol>
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Ekspedisi
            </template>
            <VSelect
              v-model="shipping"
              :options="expeditionsList"
              :clearable="false"
              class="rekonsiliasi-vselect"
              placeholder="Pilih Ekspedisi"
            />
          </BFormGroup>
        </BCol>
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class="text-7 text-black"
          >
            <template #label>
              Upload File
            </template>
            <input
              id="uploadFile"
              ref="uploadFile"
              type="file"
              accept=".xlsx,"
              class="hidden"
              @change="handleFileChange"
            >
            <div
              class="border border-red py-[5px] px-[10px] rounded-[6px] flex justify-between"
            >
              <div class="flex gap-[10px]">
                <button
                  v-if="uploadFile === null"
                  type="button"
                  class=" outline-none rounded-[6px] text-[12px] text-white p-[6px]"
                  :class="uploadFile ? 'bg-[#C2C2C2]' : 'bg-[#F95031]'"
                  @click="handleClickUpload"
                >
                  Upload File
                </button>
                <div
                  v-if="uploadFile !== null"
                  class="align-self-center"
                >
                  {{ uploadFile.name }}
                </div>
                <div
                  v-if="uploadFile === null"
                  class="text-[#C2C2C2] align-self-center"
                >
                  No file choosen
                </div>
              </div>
              <button
                v-if="uploadFile !== null"
                type="button"
                class="outline-none"
                @click="resetUpload"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/close.svg"
                  alt="close"
                >
              </button>
            </div>
          </BFormGroup>
        </BCol>
        <BCol
          md="12"
          class="mt-2"
        >
          <BFormGroup
            label-cols-md="4"
            label-class="text-7 text-black"
          >
            <template #label>
              Keterangan
            </template>
            <b-form-textarea
              id="keterangan"
              v-model="description"
              size="sm"
              maxlength="100"
              placeholder="Tulis keterangan di sini"
            />
            <div class="d-flex justify-content-end">
              <small
                class="d-flex justify-content-end"
              >{{ description.length }}/100</small>
            </div>
          </BFormGroup>
        </BCol>
      </form>
    </BRow>
    <hr class="h-[2px] bg-[#E2E2E2] text-[#E2E2E2]">
    <BRow class="justify-content-end m-1">
      <BButton
        :disabled="disabled()"
        :variant="disabled() ? 'secondary' : 'primary'"
        @click.prevent="submit()"
      >
        <b-spinner
          v-if="loadingSubmit"
          small
        />
        <span v-else>Ajukan File Excel</span>
      </BButton>
    </BRow>
  </BCard>
</template>

<script>
import VSelect from 'vue-select'
import { mapState } from 'vuex'
import '@core/scss/vue/libs/vue-select.scss'
import { listProvince } from './config'

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      loadingSubmit: false,
      province: '',
      provinceList: listProvince,
      city: '',
      cityList: [],
      shipping: '',
      uploadFile: null,
      description: '',
      expeditionsList: [],
    }
  },
  computed: {
    ...mapState('filter', ['expeditionList']),
  },
  mounted() {
    if (this.expeditionList.length === 0) {
      this.$store.dispatch('filter/getUpdateExpedition')
    }
    this.expeditionsList = this.expeditionList.map(item => item.shipping_name)
  },
  methods: {
    searchCity() {
      const params = {
        province: this.province,
      }
      this.$http_new.get('/komship/api/v1/admin/coverage-area/city-by-province', { params })
        .then(res => {
          const { data } = res.data
          this.cityList = data
        })
        .catch(err => {
          this.$toast_error({ message: 'Tidak mendapatkan list kota' })
        })
    },
    async handleFileChange() {
      const fileExcel = this.$refs.uploadFile.files[0]

      // Validasi maksimal 10MB
      const maxSizeMB = 10
      const maxSizeBytes = maxSizeMB * 1024 * 1024

      if (fileExcel && fileExcel.size > maxSizeBytes) {
        this.$toast_error({ message: 'Ukuran file melebihi 10MB' })
        this.resetUpload()
        return
      }

      this.uploadFile = fileExcel
    },
    handleClickUpload() {
      document.getElementById('uploadFile').click()
    },
    resetUpload() {
      this.$refs.uploadFile.value = ''
      this.uploadFile = null
    },
    async submit() {
      this.loadingSubmit = true
      const formData = new FormData()
      formData.append('city', this.city)
      formData.append('shipping', this.shipping)
      formData.append('note', this.description)
      formData.append('coverage_file', this.uploadFile)

      this.$http_new.post('/komship/api/v1/admin/coverage-area', formData)
        .then(res => {
          this.loadingSubmit = false
          this.$toast_success({ message: 'Berhasil Ubah Coverage Area!' })
          this.$router.push('/coverage-area')
        })
        .catch(err => {
          this.loadingSubmit = false
          this.$toast_error({ message: 'Gagal Ubah Coverage Area!' })
        })
    },
    disabled() {
      return this.province === '' || this.city === '' || this.shipping === '' || !this.uploadFile || this.description === ''
    },
  },
}
</script>
